export var PrivacyPreferenceConfigs = (function() {
    var list = ['enableShowContactInfo',
        'enableShowContactInfoToUpline',
        'enableShowContactInfoToFamily',
        'enableVisibleInSponsorSearch',
        'enableVisibleInScannerLocator',
        'showContactInfoChecked',
        'showContactInfoToUplineChecked',
        'showContactInfoToFamilyChecked',
        'visibleInSponsorSearchChecked',
        'visibleInScannerLocatorChecked'];

    var getDefaultPrivacyPreferences = function(siteConfigs) {
        var privacy = {};

        if (siteConfigs) {
            for (var property in siteConfigs.site) {
                if (typeof(property) === 'string' && list.indexOf(property) >=0) {
                    privacy[property] = siteConfigs.site[property]
                        ? siteConfigs.site[property] : false;
                }
            }
        }

        return privacy;
    };
    return {
        getDefaultPrivacyPreferences: getDefaultPrivacyPreferences
    };
})();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/util/preferences/privacy-preference-configs.js
// module id = 352
// module chunks = 0